import { render, staticRenderFns } from "./OnlineOrder.vue?vue&type=template&id=35cb617d&"
import script from "./OnlineOrder.vue?vue&type=script&lang=js&"
export * from "./OnlineOrder.vue?vue&type=script&lang=js&"
import style0 from "./OnlineOrder.vue?vue&type=style&index=0&id=35cb617d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports